import { type AuthorInfo, batchGetAuthors, getFollowing } from "@serophin/nottldr-shared";
import { useEffect, useState } from "preact/hooks";
import { AuthorsFollowed } from "../../components/profile/AuthorsFollowed";
import { ProfileTabs } from "../../components/profile/ProfileTabs";
import { useToast } from "../../contexts/ToastContext";
import type { PageProps } from "../pageProps";
import { useRequireSession } from "./useRequireSession";

/** Loads the followed authors once; an unfollow afterwards flips the card's button and leaves the card, as before. */
const useFollowedAuthors = (enabled: boolean): AuthorInfo[] | undefined => {
  const [authors, setAuthors] = useState<AuthorInfo[] | undefined>(undefined);
  const toast = useToast();

  useEffect(() => {
    if (!enabled) {
      return;
    }
    getFollowing()
      .then((aliases) => (aliases.length > 0 ? batchGetAuthors(aliases) : []))
      .then(setAuthors)
      .catch((error: unknown) => {
        console.error("Failed to load followed authors:", error);
        toast.error("Failed to load followed authors");
        setAuthors([]);
      });
  }, [enabled]);

  return authors;
};

/** `/profile/following`. */
export const FollowingPage = (_props: PageProps) => {
  const allowed = useRequireSession();
  const authors = useFollowedAuthors(allowed);
  return allowed ? (
    <>
      <ProfileTabs active="following" />
      <AuthorsFollowed authors={authors} />
    </>
  ) : null;
};
